export default __webpack_public_path__ + "static/celebrate-our-wins-072ce98e08db635c186b7bc3a6a44e5c.jpg";